import * as Sentry from "@sentry/browser";

export default function errorHandler(data: any, err: string | number) {
    Sentry.captureException(err);
    if (data?.return_url) {
        window.location.href = data.return_url;
    } else {
        window.location.href = "/error";
    }
}